import { Pagination, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchAppointmentHistory,
  fetchSelectedAppointmentDetails,
} from "../../actions/AppointmentActions";

import { callbackpatient } from "../../actions/DoctorDashboardAction";
import { fetchDoctorAppointmentHistory } from "../../actions/DoctorAppointmentActions";
import CustomeModal from "../CustomeModal/CustomeModal";
import vedioIcon from "../../assets/vidoecall.svg";
import "./appointmenthistory.css";
//import DoctorAppointmentHistoryModalContent from './AppointmentHistoryModalContent/DoctorAppointmentHistoryModalContent'
import DoctorAppointmentHistoryModalContent from "./AppointmentHistoryModalContent/DoctorAppointmentHistoryModalContent";
import Spinner from "react-bootstrap/Spinner";
import StatusBadge from "../Badges/StatusBadge/StatusBadge";
import { getConsultationStatusFlag } from "../../Helpers/ClinicAdminHelper";

function DoctorAppoinmentHistory({
  white,
  goToPrescription,
  goToCreatePrescription,
}) {
  let [modal, setModal] = useState(false);
  let [totalnoofpages, setTotalnoofpages] = useState(0);
  let [activePage, setActivePage] = useState(1);
  let dispatch = useDispatch();
  const history = useHistory();
  let reduxData = useSelector((state) => state);
  let [appointmentHistoryRedux, setappointmentHistoryRedux] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [loading, setIsLoading] = useState(true);
  const [selectedappointmentId, setSelectedappointmentId] = useState("");

  // const appointmentHistoryRedux = reduxData.doctorAppointmentHistory.doctorAppointmentHistory ?
  //reduxData.doctorAppointmentHistory.doctorAppointmentHistory : null;
  const userData = useSelector((state) => state.login.user);

  const doctorData = useSelector((state) => state.login.doctorDashboard);

  let handleTableClick = (appointmentId) => {
    setIsLoading(true); // Set loading to true before dispatching the action
    setModal(true);
    setSelectedappointmentId(appointmentId)
    // Dispatch the action
    dispatch(
      fetchSelectedAppointmentDetails({
        appointmentId: appointmentId ? appointmentId : null,
        userData,
      })
    ).then(() => {
      // This code block will be executed after the action is completed
      setIsLoading(false); // Set loading to false after the action is completed
    });
  };
  
  useEffect(() => {
    dispatch(fetchDoctorAppointmentHistory(userData?.profileId, "0")).then(
      (res) => {
        console.log("res", res);
        if (res.totalNumberOfPages != undefined) {
          //   totalnoofpages=res.data.data.totalNumberOfPages;
          setTotalnoofpages(res.totalNumberOfPages);
        }
        setLoading(false);
        setappointmentHistoryRedux(res.appointmentHistory);
      }
    );
  }, []);

  let callnowClick = (appointmentId) => {
    //   dispatch(fetchDoctorAppointmentHistory(
    //     userData?.profileId,
    // ));
    dispatch(
      callbackpatient(appointmentId ? appointmentId : null, userData?.profileId)
    ).then((res) => {
      if (res?.sessionId) {
        history.push(`/meetdr/${appointmentId}`);
      }
    });
  };
  function handleDrawerClose() {
    setModal(false);
    dispatch(
      fetchDoctorAppointmentHistory(userData?.profileId, activePage - 1)
    ).then((res) => {
      console.log("res", res);
      if (res.totalNumberOfPages != undefined) {
        //   totalnoofpages=res.data.data.totalNumberOfPages;
        //setTotalnoofpages(res.totalNumberOfPages);
      }
      //setLoading(false);
      setappointmentHistoryRedux(res.appointmentHistory);
    });
  }

  let handlePaginationChange = (e) => {
    setActivePage(e);
    // setLoader(true)
    dispatch(fetchDoctorAppointmentHistory(userData?.profileId, e - 1)).then(
      (res) => {
        console.log(
          "**************fetchAppointmentHistory API result ==> ",
          res
        );
        // setLoader(false)
        setappointmentHistoryRedux(res.appointmentHistory);
      }
    );
  };
  let getDateFull = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Friday", "Saturday"];

    let today = new Date();

    let date = today.getDate();
    let month = today.getMonth();
    let year = today.getFullYear();
    let week = today.getDay();
    console.log();
    return `${date}, ${months[month]}, ${year} - ${days[week]}`;
  };

  return (
    <>
      <div
        className={`appontment-history-container ${
          white ? "appontment-history-container-white" : ""
        }`}
      >
        {/* <div className="header"> */}
        {/* {getDateFull()} */}

        {/* <div className="filter-button">
                    <div className="icon">&nbsp;</div>
                    Filter Appointments
                </div> */}
        {/* </div> */}
        <div className="appoinment-table-wrap">
          {isLoading ? (
            <div className="loader">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : appointmentHistoryRedux && appointmentHistoryRedux?.length > 0 ? (
            <table className="appoinment-table">
              <tr>
                <th>Appointment ID</th>
                <th>Time</th>
                <th>Patient Name</th>
                <th>Consultation Status</th>
                {/* <th>Next Steps</th> */}
                <th></th>
              </tr>
              <tbody>
                {
                  //  appointmentHistoryRedux.length>0 ?
                  appointmentHistoryRedux != null ? (
                    appointmentHistoryRedux.map((element, key) => {
                      return (
                        <tr>
                          <td>{element.appointmentId}</td>
                          <td>{element.appointmentDate}</td>

                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span>{element.consultantName}</span>
                              <span style={{ margin: "5px 0" }}>
                                ({element.gender},{" "}
                                {(() => {
                                  const dob = element.dob;
                                  const dobDate = new Date(dob);
                                  const currentDate = new Date();
                                  const ageInMonths = Math.floor(
                                    (currentDate - dobDate) /
                                      (1000 * 60 * 60 * 24 * 30.4375)
                                  ); // Average number of days in a month
                                  const ageInYears = Math.floor(
                                    ageInMonths / 12
                                  );

                                  if (ageInMonths < 1) {
                                    return `1 month`;
                                  } else if (ageInMonths < 12) {
                                    return `${ageInMonths} months`;
                                  } else {
                                    return `${ageInYears} years`;
                                  }
                                })()}
                                )
                              </span>
                            </div>
                          </td>

                          {/* <td>{element.appointmentStatus}</td> */}
                          <td>{element.appointmentStatus}</td>
                          {/* <td >
                                                    Not Available
                                                </td> */}
                          <td>
                            <button
                              onClick={() => {
                                handleTableClick(element.appointmentId);
                              }}
                              className="more-btn"
                            >
                              More
                            </button>
                            {/* <button
                              onClick={() => {
                                callnowClick(element.appointmentId);
                              }}
                              className="more-btn"
                              style={{marginLeft:"15px"}}
                            >
                            <img src={vedioIcon} style={{height:"20px", width:"20px"}} alt="Video call"/>
                            
                            </button> */}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <div className="no-appointments">
                      Oops!! There is no appointment available for you.
                    </div>
                  )
                }
              </tbody>
            </table>
          ) : (
            <div className="no-appointments">
              Oops!! There is no appointment available for you.
            </div>
          )}
        </div>
        <div className="pagination-container">
          <Pagination
            showSizeChanger={false}
            onChange={handlePaginationChange}
            defaultCurrent={activePage}
            total={totalnoofpages * 10}
          />
        </div>
      </div>

      <Drawer
        className="appointmenthistoryDetailsDrawer"
        closeIcon={false}
        title={false}
        key={modal ? "1" : "2"}
        placement="right"
        onClose={handleDrawerClose}
        open={modal}
      >
        <DoctorAppointmentHistoryModalContent
          goToPrescription={goToPrescription}
          goToCreatePrescription={goToCreatePrescription}
          loading={loading}
          appointmentId={selectedappointmentId}
        />
      </Drawer>

      {/* <CustomeModal
        state={modal}
        setModal={setModal}
        component={
          <DoctorAppointmentHistoryModalContent
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
          />
        }
        isRight
      /> */}
    </>
  );
}
export default DoctorAppoinmentHistory;
